import { fetchJson } from "../utils/SuperAgentFetch";
import ResponseStatusException from "../exceptions/ResponseStatusException";
import {config} from "../config/Config";
import {showError} from "../utils/NotificationsHelper";

export const TASK_HISTORY_REQUESTED = "TASK_HISTORY_REQUESTED";
/**
 * Action for request of entry.
 *
 * @return {TaskHistoryAction}
 */
export const requestTaskHistory = () => {
  return {
    type: TASK_HISTORY_REQUESTED,
  };
};


export const TASK_HISTORY_RECEIVED = "TASK_HISTORY_RECEIVED";
/**
 *
 * @param {BaseEntryWithParent} taskHistory
 * @return {ReceiveTaskHistoryAction}
 */
export const receiveTaskHistory = (taskHistory) => {
  return {
    type: TASK_HISTORY_RECEIVED,
    taskHistory: taskHistory,
    receivedAt: Date.now(),
  };
};

export const TASK_HISTORY_ERROR = "TASK_HISTORY_ERROR";
/**
 *
 * @param {Object} error
 * @param {String} type type of action
 * @param {Number} errorResponseStatusCode
 * @param {String} errorResponseMessage
 * @return {ReceiveTaskHistoryErrorAction}
 */
export const receiveError = (
  error,
  type = TASK_HISTORY_ERROR,
  errorResponseStatusCode = null,
  errorResponseMessage = null
) => {
  return {
    type: type,
    error: error,
    errorResponseStatusCode: errorResponseStatusCode,
    errorResponseMessage: errorResponseMessage,
  };
};


/**
 * 
 *
 * @param {boolean} update if is a update request or new loading request
 * @return {function(*=, *): Promise<Object | never>}
 */
export const fetchTaskHistory = (processId,update = false) => {
  return (dispatch, getState) => {
      if (update) {
        dispatch(requestTaskHistory());
      } else {
        dispatch(requestTaskHistory());
      }

      /** @type RequestOptions options **/
      let options = {
          method: "GET",
          
      };
    
     return  fetchJson(`${config.url.API_URL}/bpmn/task/history?processInstanceId=${processId}`, options, dispatch)
     .then(json => {
        let res = [];
        if (json._embedded && json._embedded.historicTaskInstanceDtoes && json._embedded.historicTaskInstanceDtoes.length > 0 ) {
            res = json._embedded.historicTaskInstanceDtoes;
        }
       dispatch(receiveTaskHistory(res));
    }
   )  
         .catch(error => {
              if(error === "Ignoring request") {
              } else if(error instanceof ResponseStatusException) {
                  const description = error.response.message ? error.response.message : null;
                  dispatch(receiveError(error, TASK_HISTORY_ERROR, error.response.status, description));
                  showError(dispatch, error.message, description);
              } else {
                  dispatch(receiveError(error, TASK_HISTORY_ERROR));
                  showError(dispatch, error.message);
              }
          });
  }
};


